import { Box, TextField, Slider, Typography } from "@mui/material";
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import LinearProgress from '@mui/material/LinearProgress';
import Fade from '@mui/material/Fade';
import { useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  updateWelcomeMessage,
  updateScreenWelcomeMessage,
  updateEditorialContent,
  updatePlaylistIntroMessageFrequency,
  updatePlaylistIntroMessage,
  updateRadioOneIntroMessageFrequency,
  updateRadioOneIntroMessage,
  updateNewFeature,
  updateWelcomeBackground,
  updateNewFeatureBackground,
  updateOnboardingMessage,
  updateAccessibilityLabel
} from "../app/configSlice";
import { SERVER_URL } from "../app/constant";
import { useUser } from "../auth/useUser";
import { ROLE } from "../app/constant";
import { useToken } from "../auth/useToken";
import { useState } from "react";
import GridSelectorModal from "../components/GridSelectorModal";


const imageUrls = [
  "https://cbc-alexa-config.s3.us-east-1.amazonaws.com/images/welcomeBackground-default.jpg",
  "https://cbc-alexa-config.s3.us-east-1.amazonaws.com/images/background/Skill+Background+Default.png",
  // "https://cbc-alexa-config.s3.us-east-1.amazonaws.com/images/background/Orange+Background.jpg",
  // "https://cbc-alexa-config.s3.us-east-1.amazonaws.com/images/background/Red+Background.jpg",
  // "https://cbc-alexa-config.s3.us-east-1.amazonaws.com/images/background/Blue+Background.jpg",
  // "https://cbc-alexa-config.s3.us-east-1.amazonaws.com/images/background/Cyan+Background.jpg",
  // "https://cbc-alexa-config.s3.us-east-1.amazonaws.com/images/background/Yellow+Background.jpg",
  "https://cbc-alexa-config.s3.us-east-1.amazonaws.com/images/background/Winter+Image+1+Background.jpg",
  "https://cbc-alexa-config.s3.us-east-1.amazonaws.com/images/background/Winter+Image+2+Background.jpg",
  "https://cbc-alexa-config.s3.us-east-1.amazonaws.com/images/background/Winter+Image+3+Background.jpg",
  "https://cbc-alexa-config.s3.us-east-1.amazonaws.com/images/background/Winter+Image+4+Background.jpg",
 "https://cbc-alexa-config.s3.us-east-1.amazonaws.com/images/background/Spring+1.png",
 "https://cbc-alexa-config.s3.us-east-1.amazonaws.com/images/background/Spring+2.png",
 "https://cbc-alexa-config.s3.us-east-1.amazonaws.com/images/background/Spring+3.png",
 "https://cbc-alexa-config.s3.us-east-1.amazonaws.com/images/background/Spring+4.png",
 "https://cbc-alexa-config.s3.us-east-1.amazonaws.com/images/background/Summer+1.png",
 "https://cbc-alexa-config.s3.us-east-1.amazonaws.com/images/background/Fall+1.png",
 "https://cbc-alexa-config.s3.us-east-1.amazonaws.com/images/background/Fall+2.png",
 "https://cbc-alexa-config.s3.us-east-1.amazonaws.com/images/background/Fall+3.png", 
 "https://cbc-alexa-config.s3.us-east-1.amazonaws.com/images/background/Fall+4.png",  
];

const imageAlts = [
  "Default red CBC background",
  "Default dark CBC skill background",
  // "Orange background",
  // "Red background",
  // "Blue background",
  // "Cyan background",
  // "Yellow background",
  "Hiker standing on a snowy mountain peak holding a phone in a snowstorm",
  "Winter forest scene with snow-covered pine trees and a deer wearing a sweater",
  "Snowy landscape with a village and people playing pond hockey",
  "Person in headphones and a red scarf holding a CBC mug looking over a snowy landscape",
  "Two women jogging along a blooming park trail",
  "Person in a yellow raincoat walking with an umbrella",
  "People enjoying a sunny picnic in a green park",
  "Small bird perched on a blooming cherry blossom branch",
  "People relaxing and swimming at a sunny outdoor pool",
  "Forest pathway covered with colorful autumn leaves",
  "Hands holding a warm mug surrounded by autumn leaves",
  "Pumpkins and gourds surrounded by colorful autumn leaves",
  "Calm lake reflecting colorful autumn trees in the woods",
];

export { imageUrls, imageAlts };



function DynamicMessagePage() {
  const textFieldStyle = {
    mt: 2,
    backgroundColor: "white",
  }

  const dispatch = useDispatch();

  const welcomeMessage = useSelector((state) => state.config.welcomeMessage);
  const screenWelcomeMessage = useSelector(
    (state) => state.config.screenWelcomeMessage
  );
  const editorialcontent = useSelector(
    (state) => state.config.editorialcontent
  );
  const playlistIntroMessageFrequency = useSelector(
    (state) => state.config.playlistIntroMessageFrequency
  );

  const playlistIntroMessage = useSelector(
    (state) => state.config.playlistIntroMessage
  );

  const radioOneIntroMessageFrequency = useSelector(
    (state) => state.config.radioOneIntroMessageFrequency
  );

  const radioOneIntroMessage = useSelector(
    (state) => state.config.radioOneIntroMessage
  );

  let welcomeBackground = useSelector(
    (state) => state.config.welcomeBackground
  );

  const accessibilityLabel = useSelector(
    (state) => state.config.accessibilityLabel
  );

  let newFeatureBackground = useSelector(
    (state) => state.config.newFeatureBackground
  );

  const onboardingMessage = useSelector(
    (state) => state.config.onboardingMessage
  );

  const newFeature = useSelector((state) => state.config.newFeature);

  const user = useUser();
  const { role } = user;
  const [token, setToken] = useToken();
  const [welcomeImageLoader, setWelcomeImageLoader] = useState(false);
  const [newFeatureImageLoader, setNewFeatureImageLoader] = useState(false);
  const welcomeFileInputRef = useRef(null);
  const newFeatureFileInputRef = useRef(null);

  const callOpenLoader = (prependName) => {
    switch(prependName) {
      case "welcomeBackground":
        setWelcomeImageLoader(true);
        break;
      case "newFeatureBackground":
        setNewFeatureImageLoader(true);
        break;
    }
  };

  const dispatchImage = (prependName, data) => {
    switch(prependName) {
      case "welcomeBackground":
        welcomeBackground = data;
        dispatch(updateWelcomeBackground(data));
        break;
      case "newFeatureBackground":
        newFeatureBackground = data;
        dispatch(updateNewFeatureBackground(data));
        break;
    }
  };

  const onImageChange = (e, prependName) => {
    callOpenLoader(prependName);
    fetch(`${SERVER_URL}/updateImage?prependName=${prependName}`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: e.target.files[0],
    })
      .then(async (response) => {
        if (response.status == 200) {
          const data = await response.text();
          dispatchImage(prependName, data);
        } else {
          throw new Error(await response.text());
        }
      })
      .catch((error) => {
        console.log(error.message);
      })
      .finally(() => {
        setWelcomeImageLoader(false);
        setNewFeatureImageLoader(false);
      });
  };


  const OnDefault = (prependName) => {
    dispatchImage(prependName, "https://cbc-alexa-config.s3.us-east-1.amazonaws.com/images/welcomeBackground-default.jpg");
    if (prependName === "welcomeBackground") {
      dispatch(updateAccessibilityLabel(imageAlts[0] || ""));
    }
  };

  const [selectedImage, setSelectedImage] = useState(null);

  const handleImageSelection = (imageId, altText) => {
    setSelectedImage(imageId);
    console.log("image id is ", imageId);
    console.log("selected image is ", imageUrls[imageId]);
    dispatchImage("welcomeBackground", imageUrls[imageId]);
    const chosenAlt =
      altText !== undefined && altText !== ""
        ? altText
        : imageAlts[imageId] || "";
    dispatch(updateAccessibilityLabel(chosenAlt));
  };

  const currentWelcomeBackgroundIndex = imageUrls.indexOf(welcomeBackground);
  const currentBackgroundAlt =
    accessibilityLabel ||
    (currentWelcomeBackgroundIndex !== -1
      ? imageAlts[currentWelcomeBackgroundIndex]
      : "Welcome screen background preview");



  return (
    <Box>
    <h1 style={{ marginBottom: 24 }}>Dynamic Messages</h1>
      <TextField
        label="Welcome message"
        multiline
        fullWidth
        defaultValue={welcomeMessage}
        onChange={(e) => dispatch(updateWelcomeMessage(e.target.value))}
        InputLabelProps={{ shrink: true }}
        sx={{
          backgroundColor: 'white'
        }}
      />
      <TextField
        label="Screen welcome message"
        multiline
        fullWidth
        sx={textFieldStyle}
        defaultValue={screenWelcomeMessage}
        onChange={(e) => dispatch(updateScreenWelcomeMessage(e.target.value))}
        InputLabelProps={{ shrink: true }}
      />

      <Box sx={{ width: "100%", maxWidth: 400, mt: 2, mb: 2 }}>
        <Typography id="welcome-screen-upload" gutterBottom>
          Screen welcome image
        </Typography>
        <Stack
          direction="column"
          spacing={1}>
          <img
            src={welcomeBackground}
            style={{ width: "100%", maxWidth: 400 }}
            alt={currentBackgroundAlt}
          ></img>

          <Fade
            in={welcomeImageLoader}
            style={{ transitionDelay: welcomeImageLoader ? '600ms' : '0ms' }}
            unmountOnExit>
            <LinearProgress aria-label="Uploading welcome screen image" />
          </Fade>

          <Stack
            direction="row"
            spacing={2}>
            <Button
              variant="contained"
              disabled={role != ROLE.ADMIN}
              onClick={() => welcomeFileInputRef.current.click()}>
              Upload
            </Button>
            <input
              ref={welcomeFileInputRef}
              hidden
              accept="image/*"
              multiple
              type="file"
              onChange={event => onImageChange(event, "welcomeBackground")}
            />

            {/* <Button
              variant="contained"
              component="label"
              // onClick={() => OnDefault("welcomeBackground")}
              onClick={}
              disabled={role != ROLE.ADMIN}>
              Default
            </Button> */}

            <GridSelectorModal
              images={imageUrls}
              alts={imageAlts}
              onClick={handleImageSelection}
              initialAltText={accessibilityLabel || ""}
            />
      {/* {selectedBox !== null && (
        <Typography sx={{ mt: 4 }}>
          You selected box number: {selectedBox}
        </Typography>
      )} */}
          </Stack>
        </Stack>
      </Box>

      <TextField
        label="Alt text (accessibilityLabel)"
        multiline
        fullWidth
        sx={textFieldStyle}
        value={accessibilityLabel || ""}
        onChange={(e) => dispatch(updateAccessibilityLabel(e.target.value))}
        InputLabelProps={{ shrink: true }}
        helperText="In case any future images contain informative content"
      />

      <TextField
        label="Onboarding Message"
        multiline
        fullWidth
        sx={{ mt: 2 }}
        defaultValue={onboardingMessage}
        onChange={(e) => dispatch(updateOnboardingMessage(e.target.value))}
        InputLabelProps={{ shrink: true }}
      />


      <TextField
        label="Editorial content"
        multiline
        fullWidth
        sx={textFieldStyle}
        defaultValue={editorialcontent}
        onChange={(e) => dispatch(updateEditorialContent(e.target.value))}
        InputLabelProps={{ shrink: true }}
      />

      <TextField
        label="New Feature"
        multiline
        fullWidth
        sx={textFieldStyle}
        defaultValue={newFeature}
        onChange={(e) => dispatch(updateNewFeature(e.target.value))}
        InputLabelProps={{ shrink: true }}
      />
      <Box sx={{ width: "100%", maxWidth: 400, mt: 2, mb: 2 }}>
        <Typography id="newfeature-screen-upload" gutterBottom>
          New feature image
        </Typography>
        <Stack
          direction="column"
          spacing={1}>
          <img src={newFeatureBackground} style={{ width: "100%", maxWidth: 400 }} alt="New feature screen background preview"></img>

          <Fade
            in={newFeatureImageLoader}
            style={{ transitionDelay: newFeatureImageLoader ? '600ms' : '0ms' }}
            unmountOnExit>
            <LinearProgress aria-label="Uploading new feature image" />
          </Fade>

          <Stack
            direction="row"
            spacing={2}>
            <Button
              variant="contained"
              disabled={role != ROLE.ADMIN}
              onClick={() => newFeatureFileInputRef.current.click()}>
              Upload
            </Button>
            <input
              ref={newFeatureFileInputRef}
              hidden
              accept="image/*"
              multiple
              type="file"
              onChange={event => onImageChange(event, "newFeatureBackground")}
            />

            <Button
              variant="contained"
              onClick={() => OnDefault("newFeatureBackground")}
              disabled={role != ROLE.ADMIN}>
              Default
            </Button>
          </Stack>
        </Stack>
      </Box>


      <Box sx={{ width: "100%", maxWidth: 300, mt: 2 }}>
        <Typography id="playlist-intro-frequency-slider" gutterBottom>
          Playlist intro message frequency
        </Typography>
        <Slider
          defaultValue={playlistIntroMessageFrequency}
          aria-labelledby="playlist-intro-frequency-slider"
          valueLabelDisplay="auto"
          onChange={(e) =>
            dispatch(updatePlaylistIntroMessageFrequency(e.target.value))
          }
        />
      </Box>
      <TextField
        label="Playlist intro message"
        multiline
        fullWidth
        sx={textFieldStyle}
        defaultValue={playlistIntroMessage}
        onChange={(e) => dispatch(updatePlaylistIntroMessage(e.target.value))}
        InputLabelProps={{ shrink: true }}
      />
      <Box sx={{ width: "100%", maxWidth: 300, mt: 2 }}>
        <Typography id="radio-one-intro-frequency-slider" gutterBottom>
          Radio One intro message frequency
        </Typography>
        <Slider
          defaultValue={radioOneIntroMessageFrequency}
          aria-labelledby="radio-one-intro-frequency-slider"
          valueLabelDisplay="auto"
          onChange={(e) =>
            dispatch(updateRadioOneIntroMessageFrequency(e.target.value))
          }
        />
      </Box>
      <TextField
        label="Radio One intro message"
        multiline
        fullWidth
        defaultValue={radioOneIntroMessage}
        sx={textFieldStyle}
        onChange={(e) => dispatch(updateRadioOneIntroMessage(e.target.value))}
        InputLabelProps={{ shrink: true }}
      />
    </Box>
  );
}

export default DynamicMessagePage;
